import { yupResolver } from '@hookform/resolvers/yup';
import React, { FunctionComponent } from 'react';
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import * as yup from "yup";
import { RootState } from '../../../store';

const CompanyInfoSchema = yup.object().shape({
    companyName: yup.string().required(),
    companyNumber: yup.string().required(),
    companyInfo: yup.string().required(),
    webAddress: yup
        .string()
        .transform((value, originalValue) => {
            const v = String(originalValue ?? '').trim();
            if (!v) return v;
            // If no protocol is provided, assume https:// so `yup.url()` passes.
            if (!/^([a-zA-Z][a-zA-Z0-9+.-]*):\/\//.test(v)) return `https://${v}`;
            return v;
        })
        .url()
        .required(),
});

export interface ICompanyInfo {
    companyName: string,
    companyNumber: string,
    webAddress: string,
    companyInfo: string
}

interface CompanyInfoSectionProps {
    initialData?: ICompanyInfo,
    userDetails?: any,
    onSubmit: (data: ICompanyInfo) => void
}
const CompanyInfoSection: FunctionComponent<CompanyInfoSectionProps> = ({ initialData, onSubmit, userDetails }) => {
    const defaultFormValues: ICompanyInfo = {
        companyName: initialData?.companyName ?? '',
        companyNumber: initialData?.companyNumber ?? '',
        webAddress: initialData?.webAddress ?? '',
        companyInfo: initialData?.companyInfo ?? '',
    };

    const { register, handleSubmit, errors, watch } = useForm<ICompanyInfo>({
        resolver: yupResolver(CompanyInfoSchema),
        defaultValues: defaultFormValues
    })

    const watchedCompanyName = watch('companyName');
    const watchedCompanyNumber = watch('companyNumber');
    const watchedWebAddress = watch('webAddress');
    const watchedCompanyInfo = watch('companyInfo');

    const isAnyFieldEmpty = [watchedCompanyName, watchedCompanyNumber, watchedWebAddress, watchedCompanyInfo]
        .some((v) => !String(v ?? '').trim());
    const isSubmitDisabled = !userDetails ? true : isAnyFieldEmpty;

    const _onSubmit = (data: ICompanyInfo) => {
        onSubmit(data)
    }
    const genralLan = useSelector(
        (rootState: RootState) => rootState.language.language?.content!
    );
    return (
        <>
            <section className="form-wrap">
                <h4 className="com-font fw700 text-red text-capitalize">{genralLan?.general?.company_info}</h4>
                <form className="respadding com-font" onSubmit={handleSubmit(_onSubmit)}>
                    <div className="form-group">
                        <div className="row">
                            <div className="col-lg-6">
                                <input
                                    type="text"
                                    className="form-control resforminp"
                                    name="companyName"
                                    ref={register}
                                    defaultValue={defaultFormValues.companyName}
                                    placeholder={genralLan?.company?.company_name}
                                />
                                {errors.companyName && (<div className="invalid-feedback d-block">{genralLan?.company?.company_name_err}</div>)}
                            </div>
                            <div className="col-lg-6">
                                <input
                                    type="text"
                                    className="form-control resforminp"
                                    name="companyNumber"
                                    ref={register}
                                    defaultValue={defaultFormValues.companyNumber}
                                    placeholder={genralLan?.company?.company_num_place}
                                />
                                {errors.companyNumber && (<div className="invalid-feedback d-block">{genralLan?.company?.company_num_err}</div>)}
                            </div>
                            <div className="col-lg-6">
                                <input
                                    type="text"
                                    className="form-control resforminp"
                                    name="webAddress"
                                    ref={register}
                                    defaultValue={defaultFormValues.webAddress}
                                    placeholder={genralLan?.company?.website_place}
                                />
                                {errors.webAddress && (<div className="invalid-feedback d-block">{genralLan?.company?.website_err}</div>)}
                            </div>
                            <div className="col-lg-6">
                                <input
                                    type="text"
                                    className="form-control resforminp"
                                    name="companyInfo"
                                    ref={register}
                                    defaultValue={defaultFormValues.companyInfo}
                                    placeholder={genralLan?.company?.purpose}
                                />
                                {errors.companyInfo && (<div className="invalid-feedback d-block">{genralLan?.company?.purpose_err}</div>)}
                            </div>
                            <div className="col-lg-12">
                                <button type="submit" data-toggle="modal" data-target="#companyInfoModal" className="btn btn-default
                btnviewprojnext float-right text-capitalize"
                                    disabled={isSubmitDisabled}
                                >
                                    {genralLan?.general?.update_info}
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </section>

        </>

    )
}

export default CompanyInfoSection